<template>
  <div class="map-item-filter">
    <div class="col-sm-12 nopads vehicle-list">
      <div class="row px-2">
        <div class="col-2"></div>
        <div class="col-8">
          <span class="vehicle-list-title">
            {{ title ? title : $t('map.measure_distance') }}
          </span>
        </div>
        <div class="col-2">
          <div class="vehicle-list-caret" @click.stop="handleRemoveMeasureDistances">
            <font-awesome-icon icon="times-circle" />
          </div>
        </div>
      </div>
      <div class="col-sm-12 nopads vehicle-list-container">
        <div class="col-12 px-2 pb-2 text-center" style="color: #fff">
          <span class="text-light measurement-text">{{ getTotalDistance() }} km</span>
        </div>
      </div>
      <div class="d-flex flex-wrap justify-content-center px-2 pt-2 mb-2">
            <button
              class="btn btn-md btn-secondary me-2 mb-2"
              :disabled="coordinates.length < 1"
              @click.stop="undo"
            >
              {{ $t('common.undo') }}
            </button>

            <button
              class="btn btn-md btn-danger mb-2 me-2"
              @click.stop="reset"
            >
              {{ $t('common.clear') }}
            </button>

            <button
                v-if="measureDistanceTargetItem"
                class="btn btn-md btn-success mb-2"
                :disabled="coordinates.length < 2"
                @click.stop="measureDistanceTargetItemCallback(coordinates)"
            >
                {{ $t('common.save') }}
            </button>
        </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import {mapHelper} from '../mixins/MapMixin'
import {restApi} from '../mixins/RestApiMixin'

export default {
    name: 'MeasureDistanceMap',
    mixins: [timeUtils, mapHelper, restApi],
    props: {
        map: {
            type: Object,
            default: null
        },
        startPoint: {
            type: Object,
            default: null
        },
        measureDistanceTargetItem: {
            type: Object,
            default: null
        },
        measureDistanceTargetItemCallback: {
            type: Function,
            default: null
        },
        title: {
            type: String,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            coordinates: [],
            listOpen: true,
        }
    },
    mounted: function () {
        if (this.startPoint) {
            const point = {
                id: this.coordinates.length,
                position: {
                    x: this.startPoint.lng,
                    y: this.startPoint.lat
                }
            }
            this.coordinates.push(point)
            this.drawMeasureDistances()
        }
    },
    methods: {
        undo() {
            if (this.coordinates.length === 0) return
            const last = this.coordinates[this.coordinates.length - 1]
            try {
                this.map.removeMapMarker(last.id, this.MEASURE_DISTANCE)
            } catch (e) {
                // Silent error catch, matching MeasureRoadMap defensive pattern
            }
            this.coordinates.pop()
            this.hideDistances()
            this.drawMeasureDistances()
        },

        reset() {
            try {
                this.hideDistances()
            } catch (e) {
                // Silent error catch, matching MeasureRoadMap defensive pattern
            }
            this.coordinates = []
        },

        addPoint(coord) {
            this.coordinates.push({
                id: this.coordinates.length,
                position: {
                    x: coord.lng,
                    y: coord.lat
                }
            })
            this.hideDistances()
            this.drawMeasureDistances()
        },

        updatePoint(data) {
            this.coordinates[data.id] = data
            this.hideDistances()
            this.drawMeasureDistances()
        },

        async updateMeasureDistances() {
            this.loading = true
            this.initView(true)
            this.loading = false
        },

        drawMeasureDistances: function () {
            // Markers
            this.coordinates.forEach(function (measureDistance) {
                let icon = this.map.getMarkerStore().getMeasureDistanceMarkerIcon()
                this.map.showMapMarker(measureDistance.id, this.MEASURE_DISTANCE, measureDistance.position.y,
                    measureDistance.position.x, icon, true)
            }, this)
            // Lines
            const linesToDraw = this.coordinates.map((point) => {
                return point.position
            })
            if (linesToDraw.length > 1) {
                this.map.drawPolyLine(this.coordinates.length, this.MEASURE_DISTANCE, linesToDraw, "#404041", false, true)
            }
        },

        handleRemoveMeasureDistances: function () {
            this.hideDistances()
            this.coordinates = []
            this.$emit("onRemoveMeasureDistances", true)
        },

        hideDistances: function () {
            this.map.removeMapItemsByType(this.MEASURE_DISTANCE)
        },

        toggleList: function () {
            this.listOpen = !this.listOpen
        },

        getDistanceBetweenTwoPoints: function (cord1, cord2) {
            if (cord1.position.y === cord2.position.x && cord1.position.x === cord2.position.x) {
                return 0;
            }
            const radlat1 = (Math.PI * cord1.position.y) / 180;
            const radlat2 = (Math.PI * cord2.position.y) / 180;
            const theta = cord1.position.x - cord2.position.x;
            const radtheta = (Math.PI * theta) / 180;
            let dist =
                Math.sin(radlat1) * Math.sin(radlat2) +
                Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = (dist * 180) / Math.PI;
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344; //convert miles to km
            return dist;
        },


        getTotalDistance: function() {
            const coordinates = this.coordinates.filter((cord) => {
                if (cord.position.y && cord.position.x) {
                    return true
                }
            });
            let totalDistance = 0;
            if (!coordinates) {
                return 0
            }
            if (coordinates.length < 1) {
                return 0
            }
            for (let i = 0; i < coordinates.length - 1; i++) {
                totalDistance = totalDistance + this.getDistanceBetweenTwoPoints(coordinates[i], coordinates[i + 1])
            }
            return totalDistance.toFixed(2);
        }
    }
}
</script>
